import React, {useState, useEffect} from "react";
import { BASE_URL } from "../../../constants";
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Row, Col, Container, Card, Button, Form, InputGroup } from 'react-bootstrap';
import '../../../CommonCSS/SocietyCSS.css';
import "jspdf-autotable";
import { exportTrialBalExcel } from "./ExportTrialBalExcel";
import { exportTrialBalPDF } from "./ExportTrialBalPDF";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Trial_Balance = () => {

  const [ddlSectionId, setDdlSectionId] = useState();
  const [paramFromDate, setParamFromDate] = useState();
  const [paramToDate, setParamToDate] = useState();
//  const [paramPartyTot, setParamPartyTot] = useState('T');

  const [societyName, setSocietyName] = useState();
  const [trialBalData, setTrialBalData] = useState([]);
  const [ddlSections, setDdlSections] = useState([]);

  useEffect(() => {

    const fetchLists = async () => {
      try {
        const [ SectionRes] = await Promise.all([
          axios.get(`${BASE_URL}/api/ddl_sections`),
        ]);

        setDdlSections(SectionRes.data);

      } catch (err) {
        console.error("Dropdown fetch error:", err);
      }
    };

    fetchLists();

  }, []);

  const handleRunReport = async () => {

    try {

      if (!ddlSectionId || ddlSectionId === '') {
        toast.error('Please select Section.');
        return;
      } else if (!paramFromDate || paramFromDate === '') {
        toast.error('Please enter From Date.');
        return;
      } else if (!paramToDate || paramToDate === '') {
        toast.error('Please enter To Date.');
        return;
      } else if (paramFromDate > paramToDate) {
        toast.error('From Date cannot be grater than To Date.');
        return;
      }

      const response = await axios.get(`${BASE_URL}/api/rpt_trial_balance`,
        { params: { p_Section_Id: ddlSectionId, p_FromDate: paramFromDate, p_ToDate: paramToDate } });

      if (response.data.length > 0) {
        ////  Adding Total
        const totals = response.data.reduce(
          (acc, row) => {
            acc.open_bal_dr += Number(row.open_bal_dr) || 0;
            acc.open_bal_cr += Number(row.open_bal_cr) || 0;
            acc.tran_dr += Number(row.tran_dr) || 0;
            acc.tran_cr += Number(row.tran_cr) || 0;
            acc.closing_dr += Number(row.closing_dr) || 0;
            acc.closing_cr += Number(row.closing_cr) || 0;
            return acc;
          },
          {
            open_bal_dr: 0,
            open_bal_cr: 0,
            tran_dr: 0,
            tran_cr: 0,
            closing_dr: 0,
            closing_cr: 0,
          }
        );
        // Create the total row
        const totalRow = {
          particular: "GRAND TOTAL",
          ...totals,
        };
        // Append the total row to the data
        const updatedData = [...response.data, totalRow];
        setTrialBalData(updatedData);
        setSocietyName(response.data[0].scty_name);
      } else {
        setTrialBalData([]);
        toast.error('No Record available');
      }

    } catch (error) {
     toast.error('Error in Trial Balance : ', error);
   }
 
  };

  function formatCurrency(amount) {
    const numberFormat = new Intl.NumberFormat('en-IN', {
      style: 'decimal', //'currency',
      minimumFractionDigits: 2,
      currency: 'INR',
      currencyDisplay: 'symbol',
    });
    return numberFormat.format(amount);
  }

  /// Export to Excel
  const handleDownloadExcel = () => {

    exportTrialBalExcel({
      trialBalData,
      fromDate: paramFromDate,
      toDate: paramToDate,
      societyName: societyName,
    });

  };

  /// download PDF
  const handleDownloadPDF = () => {

    exportTrialBalPDF({
      trialBalData,
      fromDate: paramFromDate,
      toDate: paramToDate,
      societyName,
    });

  };

  return (
    <Container fluid className="p-3">
      {/* Header Section */}
      <Card className="mb-3 p-2">

        <Row className="mt-3">

         <Col md={4}>
            <InputGroup >
              <InputGroup.Text>Section</InputGroup.Text>
              <select className="form-select" name="ddlSectionId" value={ddlSectionId}
                onChange={(e) => setDdlSectionId(e.target.value)} >
                <option value="">-- Select Section --</option>
                {ddlSections.map(sec => (
                  <option key={sec.section_id} value={sec.section_id}>{sec.section_desc}</option>
                ))}
              </select>
            </InputGroup>
          </Col>

          <Col md={3}>
            <InputGroup>
              <InputGroup.Text>From Date</InputGroup.Text>
            <input
              type="date" style={{textAlign: 'right'}}
              className="form-control"
              value={paramFromDate}
              onChange={(e) => setParamFromDate(e.target.value)}
            />
            </InputGroup>
          </Col>

          <Col md={3}>
            <InputGroup>
              <InputGroup.Text>To Date</InputGroup.Text>
            <input
              type="date" style={{textAlign: 'right'}}
              className="form-control"
              value={paramToDate}
              onChange={(e) => setParamToDate(e.target.value)}
            />
            </InputGroup>
          </Col>

          {/* <Col md={3}>
            <InputGroup>
              <InputGroup.Text>Ledger </InputGroup.Text>
              <div className="d-flex align-items-center ms-3">
                <Form.Check type="radio" id="vendor" label="Vendor" name="paramPartyTot"
                  value="V" checked={paramPartyTot === "V"} onChange={(e) => setParamPartyTot(e.target.value)}
                  className="me-3"/>
                <Form.Check type="radio" id="total" label="Total" name="paramPartyTot"
                  value="T" checked={paramPartyTot === "T"}
                  onChange={(e) => setParamPartyTot(e.target.value)} />
              </div>
            </InputGroup>
          </Col> */}
        </Row>

        <Row className="mt-3">

          <Col md={12} className="d-flex justify-content-end">

            <Button style={{height: '40px', width: '145'}} className="me-2" variant="secondary" 
                    onClick={handleDownloadExcel} disabled={trialBalData.length === 0}>Download Excel</Button>

            <Button style={{height: '40px', width: '135'}} className="me-2" variant="warning" 
                    onClick={handleDownloadPDF} disabled={trialBalData.length === 0}>Download PDF</Button>

            <Button style={{height: '40px', width: '135'}} className="me-2" variant="success" 
                    onClick={handleRunReport} >Run Report</Button>

          </Col>
        </Row>

        {/* <Row className="mt-3">
          <Col md={12} className="d-flex justify-content-end">
            <Button className="me-2" variant="success" onClick={handleRunReport} >Run Report</Button>
            <Button className="me-2" variant="warning" onClick={handleDownloadPDF} disabled={dayBookData.length === 0}>PDF File</Button>
          </Col>
        </Row> */}

      </Card>

      {/* Details Table */}
      <Card className="p-3">
        <div style={{ minHeight: '380px' }} className="table-responsive">
          <table style={{ maxHeight: '35px' }}  className="responsive-table scty-custom-table-rcpt hover-table-rcpt">
            <thead>
              <tr>
                <th rowSpan={2} style={{ textAlign: 'left', width: '25%' }}>Particular</th>
                <th colSpan={2} style={{ textAlign: 'center', width: '20%' }}>Opening Balance</th>
                <th colSpan={2} style={{ textAlign: 'center', width: '20%' }}>Trasactions</th>
                <th colSpan={2} style={{ textAlign: 'center', width: '20%' }}>Closing Balance</th>
              </tr>
              <tr>
                <th style={{ textAlign: 'right', width: '10%' }} className="text-end">Debit Amount</th>
                <th style={{ textAlign: 'right', width: '10%' }} className="text-end">Credit Amount</th>
                <th style={{ textAlign: 'right', width: '10%' }} className="text-end">Debit Amount</th>
                <th style={{ textAlign: 'right', width: '10%' }} className="text-end">Credit Amount</th>
                <th style={{ textAlign: 'right', width: '10%' }} className="text-end">Debit Amount</th>
                <th style={{ textAlign: 'right', width: '10%' }} className="text-end">Credit Amount</th>
              </tr>
            </thead>
            <tbody>
              {trialBalData.length > 0 ? (
                trialBalData.map((tb, idx) => (
                  <tr style={{
                    fontWeight: tb.particular === 'GRAND TOTAL' ? 'bold' : 'normal',
                    backgroundColor: tb.particular === 'GRAND TOTAL' ? '#f0f0f0' : 'transparent'
                  }} >
                    <td style={{ textAlign: 'left' }}>{tb.particular}</td>
                    <td style={{ textAlign: 'right' }}>{formatCurrency(tb.open_bal_dr)}</td>
                    <td style={{ textAlign: 'right' }}>{formatCurrency(tb.open_bal_cr)}</td>
                    <td style={{ textAlign: 'right' }}>{formatCurrency(tb.tran_dr)}</td>
                    <td style={{ textAlign: 'right' }}>{formatCurrency(tb.tran_cr)}</td>
                    <td style={{ textAlign: 'right' }}>{formatCurrency(tb.closing_dr)}</td>
                    <td style={{ textAlign: 'right' }}>{formatCurrency(tb.closing_cr)}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="7" className="text-center">
                    No Record found.
                  </td>
                </tr>
              )}

            </tbody>
          </table>
        </div>

      </Card>
    </Container>
  );
};

export default Trial_Balance;
